import { v4 as createUUID } from 'uuid';

import coinflip from '@atlassian/ufo-coinflip';
import { getInteractionRate } from '@atlassian/ufo-config';
import { getActiveTrace } from '@atlassian/ufo-experience-trace-id-context';
import { DefaultInteractionID } from '@atlassian/ufo-interaction-id-context';
import { addNewInteraction } from '@atlassian/ufo-interaction-metrics';
import UFORouteName from '@atlassian/ufo-route-name-context';

export default function traceUFOPageLoad(
	ufoName: string | null | undefined,
	routeName: string | null | undefined = ufoName,
) {
	if (ufoName) {
		UFORouteName.current = ufoName;
		const rate = getInteractionRate(ufoName, 'page_load');
		if (coinflip(rate)) {
			const newId: string = createUUID();
			DefaultInteractionID.current = newId;
			addNewInteraction(newId, ufoName, 'page_load', 0, rate, null, routeName, getActiveTrace());
		}
	}
}
